<template>
  <div>
    <div class="p-16">
      <div class="max-w-5xl mx-auto space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500">
            {{ $t('roles') | capitalize }}
          </h4>
          <RouterLink
            :to="{ name: 'admin.roles.create' }"
            class="btn btn-brand style-inverted px-6"
          >
            {{ $t('newRole') | capitalize }}
          </RouterLink>
        </div>
        <DataIterat
          :headless="fetching"
          :searchable="meta && meta.last_page !== 1"
          :paginatable="meta && meta.last_page !== 1"
          v-bind="{ items: roles, loading: fetching, meta }"
          v-on="{ getData: handleGetRoles }"
        >
          <DataIteratHeaderContent slot="list-header-content" />
          <DataIteratItemContent
            slot="list-item-content"
            slot-scope="{ dataItem: role }"
            v-bind="{ role }"
          />
        </DataIterat>
      </div>
    </div>
  </div>
</template>

<script>
import DataIterat from '@/components/Ui/DataIterat.vue';
import DataIteratHeaderContent from '@/components/Roles/DataIteratHeaderContent.vue';
import DataIteratItemContent from '@/components/Roles/DataIteratItemContent.vue';
import { roleMethods, roleComputed } from '@/store/adminHelper';

export default {
  name: 'RoleList',
  components: {
    DataIterat,
    DataIteratHeaderContent,
    DataIteratItemContent,
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...roleComputed,
  },
  methods: {
    ...roleMethods,
    handleGetRoles(queryParams) {
      this.fetching = true;
      this.getRoles({ queryParams })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
